// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled),
:host ::ng-deep .mdc-text-field--focused,
:host ::ng-deep .mdc-text-field--filled,
:host ::ng-deep .mat-mdc-form-field {
  background-color: #fff !important;
  --mdc-filled-text-field-focus-active-indicator-color: none !important;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-input,
:host ::ng-deep .mat-mdc-form-field-type-mat-select {
  --mdc-filled-text-field-focus-label-text-color: black;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-input .mat-mdc-form-field-subscript-wrapper,
:host ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .mat-mdc-form-field-infix {
  min-height: 40px !important;
  padding-top: 14px !important;
  padding-bottom: 6px !important;
}
:host ::ng-deep .mat-mdc-raised-button.mat-basic {
  background-color: white;
  color: #17A2B8;
  border: 1px #17A2B8 solid;
}
:host ::ng-deep .mat-mdc-raised-button.mat-primary {
  background-color: #17A2B8;
  color: white;
}
:host ::ng-deep .mat-mdc-raised-button:disabled {
  color: grey;
}
:host ::ng-deep .cdk-overlay-pane {
  z-index: 1;
  /* Adjust value as needed */
}
:host ::ng-deep .cardContect {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
:host ::ng-deep .matoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {
  padding: 3px 8px 3px 8px !important;
}
:host ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {
  top: 22px;
}

.edit-button {
  height: 100%;
  width: 100%;
  background-color: #F5F5F5;
  border-radius: 0px 10px 0px 0px;
  cursor: pointer;
}

.delete-button {
  height: 100%;
  width: 100%;
  background-color: #F5F5F5;
  border-radius: 0px 0px 10px 0px;
  cursor: pointer;
}

.create-rule-part-1 {
  display: flex;
  flex-wrap: wrap;
  height: 50%;
  align-items: center;
  padding: 1% 2% 0% 2%;
}

.create-rule-part-2 {
  display: flex;
  flex-wrap: wrap;
  height: 50%;
  padding: 2%;
  align-items: center;
  justify-content: space-between;
  padding: 0.5% 2% 1% 2%;
}

.field {
  width: 46%;
  margin-right: 1%;
}

.select-operator {
  width: 14%;
  margin-left: 1%;
  margin-right: 1%;
}

.value {
  width: 36%;
  margin-left: 1%;
}

.rule-name {
  width: 100%;
  margin-right: 1%;
}

.add-or-edit-button {
  width: 100%;
  margin-left: 1%;
  margin-right: 0.5%;
}

.trapezoid-banner {
  width: 80%;
  height: 80%;
  background-color: #17a0b4;
  color: white;
  font-weight: bold;
  text-align: center;
  border: none;
  text-orientation: upright;
  writing-mode: vertical-lr;
  -webkit-clip-path: polygon(0% 0%, 100% 14%, 100% 85%, 0% 100%);
          clip-path: polygon(0% 0%, 100% 14%, 100% 85%, 0% 100%);
}

.clear-button {
  width: 11%;
  background-color: #17a2b8;
  color: white;
  letter-spacing: normal;
  width: 100%;
  margin-left: 0.5%;
}

.create-rules {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
}

.create-rule-sub-1 {
  width: 100%;
  height: 27%;
  display: flex;
  flex-direction: column;
}

.create-rule-sub-2 {
  height: 100%;
  display: flex;
  width: 100%;
  flex-direction: column;
}

.create-rules-container {
  display: flex;
  overflow: auto;
  background-color: #E8FCFF;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.rule-display-header {
  display: flex;
  width: 100%;
  height: 73%;
  flex-direction: column;
}

.rule-display-header-sub-1 {
  box-sizing: border-box;
  display: flex;
  height: 100%;
  background-color: #17A2B8;
  justify-content: center;
  align-items: center;
  padding-left: 3.5%;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-config-component/create-rules/create-rules.component.scss"],"names":[],"mappings":"AAEI;;;;EAII,iCAAA;EACA,qEAAA;AADR;AAII;;EAEI,qDAAA;AAFR;AAIQ;;EACI,wBAAA;AADZ;AAKI;EACI,2BAAA;EACA,4BAAA;EACA,8BAAA;AAHR;AAMI;EACI,uBAAA;EACA,cAAA;EACA,yBAAA;AAJR;AAOI;EACI,yBAAA;EACA,YAAA;AALR;AAQI;EACI,WAAA;AANR;AASI;EACI,UAAA;EACA,2BAAA;AAPR;AAUI;EAGI,uBAAA;EACA,gBAAA;EACA,mBAAA;AAVR;AAaI;EACI,mCAAA;AAXR;AAcI;EACI,SAAA;AAZR;;AAgBA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,+BAAA;EACA,eAAA;AAbJ;;AAgBA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,+BAAA;EACA,eAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AAbJ;;AAiBA;EACI,UAAA;EACA,gBAAA;AAdJ;;AAiBA;EACI,UAAA;EACA,eAAA;EACA,gBAAA;AAdJ;;AAiBA;EACI,UAAA;EACA,eAAA;AAdJ;;AAiBA;EACI,WAAA;EACA,gBAAA;AAdJ;;AAiBA;EACI,WAAA;EAKA,eAAA;EACA,kBAAA;AAlBJ;;AAsBA;EACI,UAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,8DAAA;UAAA,sDAAA;AAnBJ;;AAsBA;EACI,UAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAnBJ;;AAsBA;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAnBJ;;AAsBA;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAnBJ;;AAsBA;EACI,sBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAnBJ","sourcesContent":[":host ::ng-deep {\r\n\r\n    .mdc-text-field--filled:not(.mdc-text-field--disabled),\r\n    .mdc-text-field--focused,\r\n    .mdc-text-field--filled,\r\n    .mat-mdc-form-field {\r\n        background-color: #fff !important;\r\n        --mdc-filled-text-field-focus-active-indicator-color: none !important;\r\n    }\r\n\r\n    .mat-mdc-form-field-type-mat-input,\r\n    .mat-mdc-form-field-type-mat-select {\r\n        --mdc-filled-text-field-focus-label-text-color: black;\r\n\r\n        .mat-mdc-form-field-subscript-wrapper {\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    .mat-mdc-form-field-infix {\r\n        min-height: 40px !important;\r\n        padding-top: 14px !important;\r\n        padding-bottom: 6px !important;\r\n    }\r\n\r\n    .mat-mdc-raised-button.mat-basic {\r\n        background-color: white;\r\n        color: #17A2B8;\r\n        border: 1px #17A2B8 solid;\r\n    }\r\n\r\n    .mat-mdc-raised-button.mat-primary {\r\n        background-color: #17A2B8;\r\n        color: white;\r\n    }\r\n\r\n    .mat-mdc-raised-button:disabled {\r\n        color: grey;\r\n    }\r\n\r\n    .cdk-overlay-pane {\r\n        z-index: 1;\r\n        /* Adjust value as needed */\r\n    }\r\n\r\n    .cardContect {\r\n        // display: flex;\r\n        // justify-content: center;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .matoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {\r\n        padding: 3px 8px 3px 8px !important;\r\n    }\r\n\r\n    .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {\r\n        top: 22px\r\n    }\r\n}\r\n\r\n.edit-button {\r\n    height: 100%;\r\n    width: 100%;\r\n    background-color: #F5F5F5;\r\n    border-radius: 0px 10px 0px 0px;\r\n    cursor: pointer;\r\n}\r\n\r\n.delete-button {\r\n    height: 100%;\r\n    width: 100%;\r\n    background-color: #F5F5F5;\r\n    border-radius: 0px 0px 10px 0px;\r\n    cursor: pointer;\r\n}\r\n\r\n.create-rule-part-1 {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    height: 50%;\r\n    align-items: center;\r\n    padding: 1% 2% 0% 2%;\r\n}\r\n\r\n.create-rule-part-2 {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    height: 50%;\r\n    padding: 2%;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0.5% 2% 1% 2%;\r\n}\r\n\r\n\r\n.field {\r\n    width: 46%;\r\n    margin-right: 1%;\r\n}\r\n\r\n.select-operator {\r\n    width: 14%;\r\n    margin-left: 1%;\r\n    margin-right: 1%;\r\n}\r\n\r\n.value {\r\n    width: 36%;\r\n    margin-left: 1%;\r\n}\r\n\r\n.rule-name {\r\n    width: 100%;\r\n    margin-right: 1%;\r\n}\r\n\r\n.add-or-edit-button {\r\n    width: 100%;\r\n    // height: 50%;\r\n    // border-radius: 5px;\r\n    // background-color: #17A2B8;\r\n    // color: white;\r\n    margin-left: 1%;\r\n    margin-right: 0.5%;\r\n    // border: none;\r\n}\r\n\r\n.trapezoid-banner {\r\n    width: 80%;\r\n    height: 80%;\r\n    background-color: #17a0b4;\r\n    color: white;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    border: none;\r\n    text-orientation: upright;\r\n    writing-mode: vertical-lr;\r\n    clip-path: polygon(0% 0%, 100% 14%, 100% 85%, 0% 100%);\r\n}\r\n\r\n.clear-button {\r\n    width: 11%;\r\n    background-color: #17a2b8;\r\n    color: white;\r\n    letter-spacing: normal;\r\n    width: 100%;\r\n    margin-left: 0.5%;\r\n}\r\n\r\n.create-rules {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    flex-direction: column;\r\n}\r\n\r\n.create-rule-sub-1 {\r\n    width: 100%;\r\n    height: 27%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.create-rule-sub-2 {\r\n    height: 100%;\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: column;\r\n}\r\n\r\n.create-rules-container {\r\n    display: flex;\r\n    overflow: auto;\r\n    background-color: #E8FCFF;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.rule-display-header {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 73%;\r\n    flex-direction: column;\r\n}\r\n\r\n.rule-display-header-sub-1 {\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    height: 100%;\r\n    background-color: #17A2B8;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-left: 3.5%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
